import { on } from 'delegated-events';
import showPopup from './modals';
import { showLoader, hideLoader } from './utils/utils';

// Logowanie w popupie (przycisk „Mam konto” w kroku 2 koszyka): karta z /account/loginpopup,
// formularz wysyłany fetch-em do /account/login — błąd pokazujemy w karcie zamiast przekierowania,
// więc klient nie wypada z realizacji zamówienia; po sukcesie serwer wskazuje dokąd wrócić.
const showError = (form, message) => {
    const box = form.querySelector('[data-login-error]');
    if (!box) return;

    box.innerHTML = message || 'Logowanie nie powiodło się.';
    box.removeAttribute('hidden');
};

const sendLogin = (form) => {
    fetch(form.action, {
        method: 'POST',
        credentials: 'same-origin',
        body: new FormData(form),
        headers: {
            'X-Requested-With': 'XMLHttpRequest'
        }
    })
        .then(response => response.json())
        .then(data => {
            if (data.success) {
                window.location.assign(data.redirectUrl || window.location.href);
                return;
            }

            hideLoader();
            form.removeAttribute('data-submitting');
            showError(form, data.message);
        })
        .catch(() => {
            hideLoader();
            form.removeAttribute('data-submitting');
            showError(form, 'Nie udało się połączyć ze sklepem. Spróbuj ponownie.');
        });
};

export default function () {
    on('click', '[data-login-popup]', e => {
        e.preventDefault();

        const trigger = e.currentTarget;
        const returnUrl = trigger.getAttribute('data-return-url') || window.location.pathname;

        showLoader();

        fetch('/account/loginpopup', {
            method: 'POST',
            credentials: 'same-origin',
            body: new URLSearchParams({ returnUrl }),
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            }
        })
            .then(response => {
                if (!response.ok) throw new Error(response.status);
                return response.text();
            })
            .then(html => {
                hideLoader();

                showPopup({
                    header: 'Logowanie',
                    body: html,
                    overloadClass: 'login-modal'
                });

                const form = document.querySelector('.login-modal .login-form[data-run-validator="custom-submit-event"]');
                if (!form) return;

                // Klasę 'filled' na .field-wrapper nadaje init() walidatora (sklepowa konwencja, bez markFilledInputs).
                import('./front-validation').then(module => module.default([form], sendLogin));

                const login = form.querySelector('#login');
                if (login) login.focus();
            })
            .catch(() => {
                hideLoader();
                // Popup niedostępny (np. błąd serwera) — zwykła strona logowania nadal działa.
                window.location.assign(trigger.getAttribute('href') || '/login');
            });
    });
}
